import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";
import { reportError } from "utils/errorReporting";

import type { ExerciseFormData, ExerciseListItem } from "../schemas/exercises";

import { createExercisePayload, createLevelPayload, createTranslationPayload } from "./utils";

export const usePostExercise = () => {
  const client = useApiClient();

  return useMutation<{ tempExercise: ExerciseListItem }, Error, ExerciseFormData>(async args => {
    try {
      const exercisePayload = createExercisePayload(args);
      const exerciseResponse = await client.postExercise(exercisePayload);
      const exerciseId = exerciseResponse?.id;

      if (!exerciseId) {
        throw new Error("Failed to create exercise");
      }

      const { levels } = args;
      const level = levels[0];

      const levelPayload = createLevelPayload(level);
      const levelResponse = await client.postExerciseLevel(exerciseId, levelPayload);
      const levelId = levelResponse?.id;

      if (!levelId) {
        throw new Error("Failed to create exercise level");
      }

      const translationPayload = createTranslationPayload(level);
      const translationResponse = await client.postExerciseLevelTranslation(exerciseId, levelId, translationPayload);

      const tempExercise: ExerciseListItem = {
        ...exerciseResponse,
        levels: [{ ...levelResponse, ...translationResponse }],
        exercise_id: exerciseResponse.id,
        deleted_at: null,
        number_of_levels: 1,
      };
      return { tempExercise };
    } catch (error) {
      reportError("Failed to create exercise", new Error(JSON.stringify({ error, variables: args })));
      throw error;
    }
  });
};
